import { useConsentActions } from "../../hooks/use-consent-actions.js";
import { ConsentDetails } from "../consent-details/ConsentDetails.js";
import { ConsentDetailsRevokeModal } from "../consent-details/ConsentDetailsRevokeModal.js";
import { ConsentActionButtons } from "../consent-action-buttons/ConsentActionButtons.js";
import { useState } from "react";
import { Stack } from "@myphx-engineering/phx-design-system";
import { useDisclosure } from "@myphx-engineering/phx-design-system/hooks";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";

//#region src/client/components/profile-consent-detail/ProfileConsentDetail.tsx
const ProfileConsentDetail = ({ consent, config, loading = false }) => {
	const { ...actionConfig } = config;
	const { acceptConsent, revokeConsent } = useConsentActions(actionConfig);
	const [isAttested, setIsAttested] = useState(false);
	const [opened, { toggle }] = useDisclosure(false);
	const consentStatus = consent?.status;
	const shouldAllowConsentAttestation = !!(consentStatus && consentStatus !== "ACTIVE");
	const handleAcceptConsent = () => {
		acceptConsent(consent.document);
	};
	const handleRevokeConsent = () => {
		revokeConsent(consent.document);
		toggle();
	};
	return /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsxs(Stack, {
		gap: "lg",
		children: [/* @__PURE__ */ jsx(ConsentDetails, {
			activityDate: consent.activityDate,
			consent: consent.document,
			status: consent.status,
			onCheckboxChange: () => setIsAttested(!isAttested),
			isAttested,
			shouldAllowConsentAttestation
		}), /* @__PURE__ */ jsx(ConsentActionButtons, {
			consent: consent.document,
			isAttested,
			shouldAllowConsentAttestation,
			loading,
			onAccept: handleAcceptConsent,
			onRevoke: toggle
		})]
	}), /* @__PURE__ */ jsx(ConsentDetailsRevokeModal, {
		consent: consent.document,
		opened,
		onClose: toggle,
		handleConsentAction: handleRevokeConsent
	})] });
};

//#endregion
export { ProfileConsentDetail };